import React from "react";

import i18next from "external/i18n";

export const HistoryContent = () => (
  <>
    <p>{i18next.t("help.details.content.history.content.paragraph")}</p>
  </>
);
